import { BracketTypeMap, ColumnOption, Database } from "../constants/schema.js";
import { bHas } from "./bit.js";
//#region src/utils/tableName.ts
function getBracket(bracketType) {
	return BracketTypeMap[bracketType] ?? "";
}
var NAME_PART = /(?:\[(?:[^\]]|\]\])*\]|"(?:[^"]|"")*"|[^.])*/y;
var DELIMITED_PART = /^(?:\[((?:[^\]]|\]\])*)\]|"((?:[^"]|"")*)")$/;
function splitNameParts(name) {
	const parts = [];
	let index = 0;
	do {
		NAME_PART.lastIndex = index;
		const [part] = NAME_PART.exec(name);
		parts.push(part);
		index += part.length + 1;
	} while (index <= name.length);
	return parts;
}
function isDelimitedPart(part) {
	return DELIMITED_PART.test(part);
}
function unquoteNamePart(part) {
	const match = DELIMITED_PART.exec(part);
	if (!match) return part;
	const [, bracketed, quoted] = match;
	return bracketed === void 0 ? quoted.replaceAll("\"\"", "\"") : bracketed.replaceAll("]]", "]");
}
function splitTableName(name, bracketType) {
	if (getBracket(bracketType) !== "") return ["", name];
	const parts = splitNameParts(name);
	const table = parts[parts.length - 1];
	return parts.length === 1 ? ["", name] : [name.slice(0, name.length - table.length - 1), table];
}
function tableNamePart(name, bracketType) {
	const [, table] = splitTableName(name, bracketType);
	return getBracket(bracketType) === "" ? unquoteNamePart(table) : table;
}
var TABLE_NAME_PART_DATABASES = /* @__PURE__ */ new Set([
	Database.MariaDB,
	Database.MSSQL,
	Database.MySQL,
	Database.Oracle,
	Database.PostgreSQL,
	Database.SQLite
]);
function splitsTableName(database) {
	return TABLE_NAME_PART_DATABASES.has(database);
}
function orderByNameASC(a, b) {
	const nameA = a.name.toLowerCase();
	const nameB = b.name.toLowerCase();
	if (nameA < nameB) return -1;
	else if (nameA > nameB) return 1;
	return 0;
}
function autoName(list, id, name, num = 1) {
	return numberName(list, id, name, num, (value) => value);
}
function autoNameIgnoreCase(names, name) {
	return numberName(names, "", name, 1, (value) => value.toLowerCase());
}
function numberName(list, id, name, num, fold) {
	const folded = fold(name);
	if (!(name !== "" && list.some((value) => value.id !== id && fold(value.name) === folded))) return name;
	return numberName(list, id, name.replace(/[0-9]/g, "") + num, num + 1, fold);
}
function primaryKeyColumns(columns) {
	return columns.filter(({ options }) => bHas(options, ColumnOption.primaryKey));
}
//#endregion
export { autoName, autoNameIgnoreCase, getBracket, isDelimitedPart, orderByNameASC, primaryKeyColumns, splitNameParts, splitTableName, splitsTableName, tableNamePart, unquoteNamePart };
